import React, {useState} from "react";
import SubmissionListsList from "./SubmissionListsList";




const RecentSubmissionLists = ({
    initialSubmissionLists,
    isMiddleman,
    isSuperMiddleman,
    submissionListsAnimationDivider
  }) => {

  const [submissionLists, setSubmissionLists] = useState(JSON.parse(initialSubmissionLists));

  return (
    <React.Fragment>
      <SubmissionListsList
        submissionLists={submissionLists}
        setSubmissionLists={setSubmissionLists}
        isMiddleman={isMiddleman}
        isSuperMiddleman={isSuperMiddleman}
        submissionListsAnimationDivider={submissionListsAnimationDivider}
      />
    </React.Fragment>
  );
};

export default RecentSubmissionLists;